var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('mymask',{attrs:{"loaded":_vm.loaded}}),_vm._v(" "),_c('Header'),_vm._v(" "),_c('BrandIntro'),_vm._v(" "),_c('ProductIntro'),_vm._v(" "),_c('FlowerList'),_vm._v(" "),_c('CardDownload')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-311ab623","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Index/layout.vue
// module id = 158
// module chunks = 0